import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import { ActionButtons } from "./WarehouseTruckList.styled";
import "./WarehouseTruckList.scss";
import { handleApiError } from "@utils/errorHandler";

const WarehouseTruckAction = (props) => {
  const {
    t,
    data,
    onRefreshData,
    carrierId,
    companyId,
    warehouseId,
    setTrucksList,
    updateWarehouseRefeshStatus,
    createWarehouseTruck,
  } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState("");
  const [confirmationBoxContent, setConfirmationBoxContent] = useState("");

  const handleWarehouseStatus = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("WAREHOUSE_TRUCKS_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent(
        "WAREHOUSE_TRUCKS_CONFIRMATION_BOX_ENABLE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("WAREHOUSE_TRUCKS_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "WAREHOUSE_TRUCKS_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .post(
          `/companies/${companyId}/hauliers/${carrierId}/warehouses/${warehouseId}/trucks/${data.id}/updateStatus`,
          data.status === true ? `0` : 1
        )
        .then((response) => {
          setTrucksList(response.data.trucks);
          onRefreshData(true);
          updateWarehouseRefeshStatus();
          setActionConfirmStatus(false);
        })
        .catch((error) => {
          onRefreshData(false);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <ActionButtons>
      <>
        <>
          {!!data.status && (
            <>
              <Image
                src={editIcon}
                onClick={createWarehouseTruck}
                alt={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_EDIT")}
                title={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_EDIT")}
                className="warehouses-list__image-icon"
              />
              <Image
                src={deleteIcon}
                onClick={() => handleWarehouseStatus(0)}
                alt={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_DISABLE")}
                title={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_DISABLE")}
                className="warehouses-list__image-icon"
              />
            </>
          )}
          {!data.status && (
            <Image
              src={activateIcon}
              onClick={() => handleWarehouseStatus(1)}
              alt={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_ACTIVATE")}
              title={t("WAREHOUSE_TRUCKS_ACTION_TOOLTIP_ACTIVATE")}
              className="warehouses-list__image-icon"
            />
          )}
        </>
      </>
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ActionButtons>
  );
};

WarehouseTruckAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
    status: PropTypes.bool,
  }).isRequired,
  t: PropTypes.func.isRequired,
  isUpdateState: PropTypes.bool,
};

WarehouseTruckAction.defaultProps = {
  isUpdateState: false,
};
export default withTranslation()(WarehouseTruckAction);
